<template>
  <div>
    <form data-vv-scope="step-2-part-1">
      <div class="row mb-5">
        <div class="col-12">
          <h4>Datos de la persona que ingresa el documento</h4>
        </div>
        <div class="col-md-12">
          <list-user-groups
            class="w-100"
            autocomplete
            only-groups
            label="Grupo al que irá asociado el expediente (*)"
            name="creatorGroup"
            v-model="step.creatorGroup"
            :danger="errors.has('step-2-part-1.creatorGroup')"
            :danger-text="errors.first('step-2-part-1.creatorGroup')"
            v-validate="{ required: userGroupsState.list.length > 1 }"
            ref="creatorGroup"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <h4>Origen / Datos Remitente</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <list-institution-types
            class="w-100"
            autocomplete
            label="Tipo Institución (*)"
            name="institutionType"
            v-model="step.institutionType"
            :danger="errors.has('step-2-part-1.institutionType')"
            :danger-text="errors.first('step-2-part-1.institutionType')"
            v-validate="'required'"
            ref="institutionType"
          />
        </div>
        <div class="col-md-6">
          <list-institutions
            class="w-100"
            autocomplete
            label="Institución"
            name="institution"
            v-model="step.institution"
            :parent-value="step.institutionType"
            ref="institution"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-input
            class="w-100"
            label="Nombre Persona"
            maxlength="50"
            name="personName"
            v-model="step.personName"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <vs-input
            class="w-100"
            label="Cargo Persona"
            maxlength="50"
            name="personPosition"
            v-model="step.personPosition"
          />
        </div>
        <div class="col-6">
          <vs-input
            class="w-100"
            label="Correo Persona"
            maxlength="70"
            name="personEmail"
            v-validate="'email'"
            :danger="errors.has('step-2-part-1.personEmail')"
            :danger-text="errors.first('step-2-part-1.personEmail')"
            v-model="step.personEmail"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <vs-input
            class="w-100"
            label="Teléfono Persona"
            maxlength="16"
            placeholder="Escriba en formato +56912345678"
            v-validate="{ regex: phoneRegex }"
            name="personPhone"
            v-model="step.personPhone"
            :danger="errors.has('step-2-part-1.personPhone')"
            :danger-text="errors.first('istep-2-part-1.personPhone')"
            :success="!errors.has('step-2-part-1.personPhone') && step.personPhone.length > 0"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="step-2-part-2">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Destinatario (*)</h4>
        </div>
      </div>
      <SelectSubject @add-subject="addSubject" />
      <div class="row mb-3">
        <div class="col-12">
          <TableSubjects
            :subjects="step.subjects"
            v-model="step.subjectsSelected"
          />
        </div>
      </div>
    </form>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    <form data-vv-scope="step-2-part-3">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Con copia a</h4>
        </div>
      </div>
      <SelectCopy @add-copy="addCopy" />
      <div class="row mb-3">
        <div class="col-12">
          <TableCopies
            :copies="step.copies"
            v-model="step.copiesSelected"
          />
        </div>
      </div>
    </form>
    <div class="row mb-3">
      <div class="col-12">
        <vs-divider />
      </div>
    </div>
    <form data-vv-scope="step-2-part-4">
      <div class="row mb-3">
        <div class="col-md-6">
          <vs-select
            class="w-100"
            autocomplete
            label="Acompaña Físico"
            name="esFisico"
            v-model="step.withAttachment"
          >
            <vs-select-item
              :value="0"
              text="No"
            />
            <vs-select-item
              :value="1"
              text="Si"
            />
          </vs-select>
        </div>
        <div class="col-md-6" v-if="step.withAttachment">
          <vs-input
            class="w-100"
            label="Detalle"
            maxlength="250"
            name="documentDetail"
            v-model="step.documentDetail"
            v-validate="{ required: step.withAttachment === 1 }"
            :danger="errors.has('step-2-part-4.documentDetail')"
            :danger-text="errors.first('step-2-part-4.documentDetail')"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <vs-input
            class="w-100"
            label="Resumen materia"
            maxlength="250"
            name="resumen"
            v-model="step.resumen"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label for="observation">Observación</label>
          <vs-textarea
            id="observation"
            maxlength="5000"
            label="Observacion (5000 caracteres)"
            name="observacion"
            v-model="step.observation"
            width="100%"
            height="100px"
          />
        </div>
      </div>
      <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
           style="height: 32px;">
          <span class="span-text-validation">
            {{error.message}}
          </span>
      </div>
    </form>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import ListInstitutions from '@/febos/chile/lists/components/ListInstitutions';
import ListInstitutionTypes from '@/febos/chile/lists/components/ListInstitutionTypes';
import ListUserGroups from '@/febos/chile/lists/components/ListUserGroups';
import SelectSubject from '@/febos/chile/dnt/components/wizard/subjects/SelectSubject';
import SelectCopy from '@/febos/chile/dnt/components/wizard/subjects/SelectCopy';
import TableSubjects from '@/febos/chile/dnt/components/wizard/subjects/TableSubjects';
import TableCopies from '@/febos/chile/dnt/components/wizard/subjects/TableCopies';

export default {
  mixins: [WizardStep],
  components: {
    ListInstitutionTypes,
    ListInstitutions,
    ListUserGroups,
    SelectSubject,
    SelectCopy,
    TableSubjects,
    TableCopies
  },
  data() {
    return {
      error: {
        message: ''
      },
      phoneRegex: /^[+][0-9]{10,11}$/,
      emailRequired: ['personas', 'empresas', 'ministerios'],
      isInput: ['personas', 'empresas'],
      subjectForm: {
        subjectType: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      },
      copySubjectForm: {
        copySubjectType: '',
        copySubject: '',
        copySubjectTypeDigitalDoc: '',
        copySubjectEmail: '',
      },
      step: {
        creatorGroup: '',
        institutionType: '',
        institution: '',
        personName: '',
        personPosition: '',
        personEmail: '',
        personPhone: '',
        withAttachment: 0,
        documentDetail: '',
        resumen: '',
        observation: '',
        subjects: [],
        copies: [],
        subjectsSelected: [],
        copiesSelected: [],
        ...this.draft
      }
    };
  },
  watch: {
    subjects(newValue) {
      this.subjectsSelected = newValue;
      this.subjects = newValue;
    },
    copies(newValue) {
      this.copiesSelected = newValue;
      this.copies = newValue;
    }
  },
  computed: {
    // TODO: move this getter to the ListUserGroups component
    ...mapGetters('List', [
      'userGroupsState'
    ]),
    ...mapGetters('Dnts', [
      'wizardData'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ])
  },
  methods: {
    async addSubject(row) {
      if (row.subject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }

      const isSelected = this.step.subjectsSelected
        .some((subjectRow) => {
          if (subjectRow.subjectType.value === 'docDigital') return subjectRow.subjectTypeDigitalDoc.id === row.subjectTypeDigitalDoc.id;

          return subjectRow.subject.id === row.subject.id;
        });

      if (!isSelected) {
        this.step.subjects.push(row);
        this.step.subjectsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste este destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async addCopy(row) {
      if (row.copySubject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como copia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }
      const isSelected = this.step.copiesSelected
        .some((copyRow) => {
          if (copyRow.copySubjectType.value === 'docDigital') return copyRow.copySubjectTypeDigitalDoc.id === row.copySubjectTypeDigitalDoc.id;

          return copyRow.copySubject.id === row.copySubject.id;
        });
      if (isSelected) {
        this.$bvToast.toast(
          'Ya agregaste esta copia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }

      this.step.copies.push(row);
      this.step.copiesSelected.push(row);
    },
    async isValid() {
      const stepValidations = await Promise.all([
        this.validateForm('step-2-part-1'),
        this.validateForm('step-2-part-4'),
      ]);

      if (stepValidations.some((step) => !step)) {
        return false;
      }

      if (!this.step.subjectsSelected.length) {
        this.error.message = 'Debes agregar al menos un destino';
        return false;
      }

      return true;
    },
    getStepData() {
      const institutionTypeName = this.step.institutionType
        ? {
          institutionTypeName: this.$refs.institutionType.getOption().label
        }
        : {};

      const institutionName = this.step.institution
        ? {
          institutionName: this.$refs.institution.getOption().label
        }
        : {};

      const creatorGroupName = this.step.creatorGroup
        ? {
          creatorGroupName: this.$refs.creatorGroup.getOption().label
        }
        : {};

      return {
        ...this.step,
        ...institutionTypeName,
        ...institutionName,
        ...creatorGroupName
      };
    }
  },
  created() {
    if (this.userGroupsState.list.length === 1) {
      this.step.creatorGroup = this.userGroupsState.list[0].id;
      this.step.creatorGroupName = this.userGroupsState.list[0].label;
    }
    // Esto se usa desde un principio como descripción de flujo, no borrar
    this.step.resumen = (this.wizardData.matter || '').slice(0, 50);
  }
};

</script>
